<template>
	<!-- Table Question -->
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th
						class="th-question__type "
						@click="sortColumn('cmsLifestyleQuestionType.questionType')"
					>
						<div class="th-sort">
							<span>{{ $t('questionType') }} </span>
							<span
								v-if="sortedColumn === 'cmsLifestyleQuestionType.questionType'"
							>
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__text" @click="sortColumn('question')">
						<div class="th-sort">
							<span>{{ $t('questionText') }}</span>

							<span v-if="sortedColumn === 'question'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th
						class="th-question__answer"
						@click="sortColumn('cmsLifeStyleQuestionFormat.questionFormat')"
					>
						<div class="th-sort">
							<span>{{ $t('answerType') }}</span>
							<span
								v-if="
									sortedColumn === 'cmsLifeStyleQuestionFormat.questionFormat'
								"
							>
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__only-post">{{ $t('onlyPost') }}</th>
					<th class="th-question__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr class="search-row">
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchQuestionType" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchQuestionText" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchAnswerType" />
						</label>
					</td>
					<td></td>
					<td></td>
				</tr>
				<tr
					v-for="(row, index) in displayedData"
					:key="index"
					class="table-row"
				>
					<td>{{ row.cmsLifestyleQuestionType.questionType }}</td>
					<td>{{ row.question }}</td>
					<td>{{ row.cmsLifeStyleQuestionFormat.questionFormat }}</td>
					<td class="td-checkbox td-center">
						<input
							type="checkbox"
							class="checkbox"
							:checked="row.isAtEndOfSimulation"
							disabled
						/>
					</td>
					<td class="td-center">
						<button
							v-if="validateAccess(row)"
							class="action-button"
							@click="editRow(row)"
						>
							<svgicon name="pencil"></svgicon>
						</button>
						<button
							v-if="validateAccess(row)"
							class="action-button"
							@click="openDeleteModal(row)"
						>
							<svgicon name="trash"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="filteredData.length"
			@changePage="setAllPage"
		></ja-pagination>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteLifeQuestion()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: $t('evaluationQuestion')
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import AdminFacility from '@/mixins/AdminFacility';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaPagination: Pagination
	},
	mixins: [AdminFacility],
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			currentPage: 1,
			itemsPerPage: 150,
			searchQuestionType: '',
			searchQuestionText: '',
			searchAnswerType: '',
			rowToDelete: null
		};
	},
	computed: {
		filteredData() {
			if (this.data) {
				let filteredData = this.data.filter(
					row =>
						row.cmsLifeStyleQuestionFormat.questionFormat
							.toLowerCase()
							.includes(this.searchAnswerType.toLowerCase()) &&
						row.question
							.toLowerCase()
							.includes(this.searchQuestionText.toLowerCase()) &&
						row.cmsLifestyleQuestionType.questionType
							.toLowerCase()
							.includes(this.searchQuestionType.toLowerCase())
				);

				if (this.sortedColumn) {
					filteredData = filteredData.sort((a, b) => {
						if (this.sortedColumn.includes('.')) {
							const keys = this.sortedColumn.split('.');
							let fieldA = a;
							let fieldB = b;
							for (const key of keys) {
								fieldA = fieldA[key];
								fieldB = fieldB[key];
							}
							return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
						} else {
							const fieldA = a[this.sortedColumn].toLowerCase();
							const fieldB = b[this.sortedColumn].toLowerCase();
							return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
						}
					});
				}
				return filteredData;
			}
			return [];
		},
		displayedData() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const filteredData = this.filteredData.slice(
				start,
				start + this.itemsPerPage
			);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		},
		hasAccess() {
			return this.isSuperAdmin || this.isUSAAdmin;
		}
	},
	watch: {
		displayedData() {
			this.currentPage = this.currentPage <= 0 ? 1 : this.currentPage;
		}
	},
	methods: {
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			this.$emit('editRow', row);
		},
		openDeleteModal(row) {
			this.rowToDelete = row;
			this.showMessageDeletionModal = true;
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		deleteLifeQuestion() {
			if (this.rowToDelete) {
				this.$emit('deleteRow', this.rowToDelete);
			}
			this.showMessageDeletionModal = false;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		},
		validateAccess(rowData) {
			return this.hasAccess || !rowData.isNonEditable;
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.td-input {
	padding: 0;
}
.th-question {
	&__type {
		width: 16%;
	}
	&__text {
		width: 50%;
	}
	&__answer {
		width: 14%;
	}
	&__only-post {
		width: 10%;
	}
	&_actions {
		width: 10%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}
.custom-input {
	display: flex;
	border-radius: 4px;
	border: 1px solid #ddd;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
	padding: 7px 5px;
	margin: 1px;
	gap: 5px;
}

.custom-input input {
	border: none;
	outline: none;
	width: 100%;
}
.custom-input:focus-within {
	outline: 2px solid $hover-state;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
